import { CRAWL_REQUEST_API_PREFIX } from '@aibees/elephant/constants';
import {
  CreateCrawlRequestRequest,
  CreateCrawlRequestResponse,
} from '@aibees/elephant/types/crawl-request';
import { HttpMethod } from '@aibees/shared/definition';
import { useDebounceFn, useNotify } from '@aibees/shared/hooks';
import { useBaseMutation } from '@aibees/shared/http';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useWorkspace } from '@aibees/shared/workspace';
import { random } from 'lodash-es';
import { notificationIconMap } from '../utils';
import { useBrowseCrawlRequestsApi } from './use-browse-crawl-requests-api';

export function useCreateCrawlRequestMutationApi() {
  const workspaceId = useWorkspace()?.id;
  const notify = useNotify();

  const invalidateDebounced = useDebounceFn(() => {
    baseQueryClient.invalidateQueries([useBrowseCrawlRequestsApi.name]);
  }, 1000);

  return useBaseMutation<CreateCrawlRequestRequest, CreateCrawlRequestResponse>(
    {
      url: CRAWL_REQUEST_API_PREFIX.replace(':wid', String(workspaceId)),
      method: HttpMethod.post,
    },
    {
      onSuccess: () => {
        notify.progress(
          'Processing Your Request',
          'Your request is queued and will be processed. Please wait until the current task completes.',
          random(1, 101),
          {
            icon: notificationIconMap.CRAWL,
          }
        );
      },

      onSettled() {
        invalidateDebounced();
      },
    }
  );
}
